import { subscriptionAccess } from "./es.subscription-access";
import { subscriptionCancel } from "./es.subscription-cancel";
import { subscriptionDetails } from "./es.subscription-details";
import { subscriptionInvoices } from "./es.subscription-invoices";
import { subscriptionManage } from "./es.subscription-manage";
import { subscriptionRenew } from "./es.subscription-renew";
import { subscriptionSettings } from "./es.subscription-settings";

export const subscriptionManagement = {
  ...subscriptionAccess,
  ...subscriptionCancel,
  ...subscriptionDetails,
  ...subscriptionInvoices,
  ...subscriptionManage,
  ...subscriptionRenew,
  ...subscriptionSettings,
};
